import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";

export const devRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "Dev", breadcrumbNavigate: false },
    async lazy() {
      const { RedoDevOnlyGuard } =
        await import("@redotech/redo-merchant-support-app/dev/redo-dev-only-guard");
      return { Component: RedoDevOnlyGuard };
    },
    children: [
      {
        path: "editor-testing",
        handle: { breadcrumb: "FAQ editor testing" },
        async lazy() {
          const { EditorTestingPage } =
            await import("./editor-testing/editor-testing-page");
          return { Component: EditorTestingPage };
        },
      },
      {
        path: "client-side-tools",
        handle: { breadcrumb: "Client-side tools" },
        async lazy() {
          const { ClientSideToolsPage } =
            await import("./client-side-tools/client-side-tools-page");
          return { Component: ClientSideToolsPage };
        },
      },
      {
        path: "stream-tester",
        handle: { breadcrumb: "Stream tester" },
        async lazy() {
          const { StreamTesterPage } =
            await import("./stream-tester/stream-tester-page");
          return { Component: StreamTesterPage };
        },
      },
      {
        path: "voice-v2",
        handle: { breadcrumb: "Voice v2" },
        async lazy() {
          const { VoiceV2Page } = await import("./voice-v2/voice-v2-page");
          return { Component: VoiceV2Page };
        },
      },
    ],
  },
];
